import { UserCircleIcon } from "@heroicons/react/24/outline";
import { Accordion } from "@via/components/accordion/accordion";
import FormInputComponent from "@via/components/inputs/form-input-component";
import { addUserGroupMemberOptions } from "@via/utils/form-validators";
import { type JSX } from "react";
import { useForm } from "react-hook-form";
import { useAddUserGroupMember } from "@via/api/user-groups.api.tsx";

export default function AddUserGroupMember({
  groupId,
}: {
  groupId: number;
}): JSX.Element {
  const { control, handleSubmit } = useForm<{
    email: string;
  }>({
    mode: "onChange",
  });

  const {
    mutateAsync: addUserGroupMember,
    isPending: isAddUserGroupMemberLoading,
  } = useAddUserGroupMember();

  const handleAddUserGroupMember = async (payload: { email: string }) => {
    await addUserGroupMember({ groupId, ...payload });
  };

  return (
    <Accordion
      title="Add New Group Member"
      testId="addUserGroupMemberAccordion">
      <form
        onSubmit={e => {
          e.preventDefault();
          void handleSubmit(handleAddUserGroupMember)(e);
        }}>
        <div className="mb-4 flex items-start gap-2">
          <div className="flex-1">
            <FormInputComponent
              control={control}
              name="email"
              label="User E-mail"
              placeholder="Enter User E-mail"
              validations={addUserGroupMemberOptions.email}
              disabled={isAddUserGroupMemberLoading}
              showRequiredField
            />
          </div>
          <button
            disabled={isAddUserGroupMemberLoading}
            type="submit"
            data-testid="addGroupMemberButton"
            className="mt-10 whitespace-nowrap bg-indigo-600 text-white hover:bg-indigo-500 hover:shadow-md inline-flex gap-x-1.5 rounded-md px-3 py-2 text-sm shadow-sm duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            <UserCircleIcon className="h-5 w-5" aria-hidden="true" />
            Add Member
          </button>
        </div>
      </form>
    </Accordion>
  );
}
